import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../../components/Navbar/Navbar';
import Sidebar from '../../components/Sidebar/Sidebar';
import styles from './Dashboard.module.scss';

const Dashboard: React.FC = () => {
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  // Route protection
  useEffect(() => {
    const auth = localStorage.getItem('lendsqr_auth');
    if (!auth) {
      navigate('/login');
    }
  }, [navigate]);

  const stats = [
    {
      label: 'Users',
      value: '2,453',
      colorClass: 'pink',
      icon: (
        <svg width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="#DF18FF" strokeWidth={1.8}>
          <path strokeLinecap="round" d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/>
          <circle cx="9" cy="7" r="4"/>
          <path strokeLinecap="round" d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75"/>
        </svg>
      ),
    },
    {
      label: 'Active Users',
      value: '2,453',
      colorClass: 'purple',
      icon: (
        <svg width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="#5718B2" strokeWidth={1.8}>
          <path strokeLinecap="round" d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/>
          <circle cx="9" cy="7" r="4"/>
          <path strokeLinecap="round" d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75"/>
        </svg>
      ),
    },
    {
      label: 'Users with Loans',
      value: '12,453',
      colorClass: 'red',
      icon: (
        <svg width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="#E4033B" strokeWidth={1.8}>
          <path strokeLinecap="round" d="M9 8h6m-5 0a3 3 0 110 6H9l3 3m-3-6h6m6 1a9 9 0 11-18 0 9 9 0 0118 0z"/>
        </svg>
      ),
    },
    {
      label: 'Users with Savings',
      value: '102,453',
      colorClass: 'gold',
      icon: (
        <svg width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="#E9B200" strokeWidth={1.8}>
          <path strokeLinecap="round" d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2z"/>
        </svg>
      ),
    },
  ];

  return (
    <div className={styles.dashboardLayout}>

      {/* Sidebar */}
      <Sidebar isOpen={sidebarOpen} />

      {/* Main */}
      <div className={styles.mainContent}>

        {/* Navbar */}
        <Navbar onMenuClick={() => setSidebarOpen(!sidebarOpen)} />

        {/* Content */}
        <div className={styles.pageContent}>
          <div className={styles.pageHeader}>
            <h1>Dashboard</h1>
          </div>

          {/* Stats */}
          <div className={styles.statsGrid}>
            {stats.map((stat, index) => (
              <div key={index} className={styles.statCard}>
                <div className={`${styles.statIcon} ${styles[stat.colorClass]}`}>
                  {stat.icon}
                </div>
                <p className={styles.statLabel}>{stat.label}</p>
                <h3 className={styles.statValue}>{stat.value}</h3>
              </div>
            ))}
          </div>

        </div>
      </div>

    </div>
  );
};

export default Dashboard;